/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

function setStyle(el, styles) {
  var keys = Object.keys(styles);
  keys.forEach(function (key) {
    el.style[key] = styles[key];
  });
}

export { setStyle as default };
//# sourceMappingURL=set-style.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/_common/js/utils/set-style.js
// module id = null
// module chunks = 